import React, { Component } from "react";
import { withRouter } from "next/router";

export default class index extends Component {
  render() {
    return (
      <div className="mainindiacontent">
        <h2>How to Check What Happened to Your iPhone - DIY</h2>
        <p className="content2">
          If your iPhone is acting up for a while, it’s important to know what
          you should do as your first step. If you are unable to do anything,
          however; you should definitely give a call at our Apple device repair
          shop in India. However, you need to know how to diagnose the issue by
          yourself too. So, let’s get some information on that.
          <br/>
          <br/>          
            <h3>1: Look for Physical Damage</h3>
            If your device is shutting off too frequently, it might be caused by
            a physical damage it might have sustained before. So, be sure to
            look for cracks, scratches, and dents on it. If you’ve found a
            cracked screen, give a call at our no warranty iPhone repair service
            in India. You can either search for iphone screen repair cost in
            India or wait for our technicians to offer their verdict on it. The
            latter is a bit time-taking but you’ll get a correct answer.
            <br/>
          <br/>
            <h3>2: Restart Your Phone</h3>
            This is probably the most basic troubleshooting technique of all
            time. While it might not be able to take care of the issues related
            to your device’s software or hardware, it’ll surely ensure that the
            pesky stutters are taken care of.
            <br/>
          <br/>
            <h3>3: Check Battery Health</h3>
         
          If your iPhone’s battery is draining too quickly, do the following -
          <br />
          <ul>
            <li>Go to Settings</li>
            <li>Find out an option called ‘Battery’</li>
            <li>Then click on ‘Battery health’</li>
          </ul>
          This will help you check the maximum capability of your device. If you
          find it to be under 80 percent, it might be time for you to get the
          battery replaced.
        </p>
      </div>
    );
  }
}
 